<template>
    <div id="overlay" >
        <div id="main" style="height: 90%;min-height: 500px;max-height: 630px;width: 95%;max-width: 800px;padding: 10px;background-color: white;display: flex;flex-direction: column;justify-content: space-between;">
         
              <div style="width: 100%;padding-top: 10px;">
                <div >
                  <div style="display: flex;justify-content: space-between;align-items: flex-end;">
                    <div style="font-size:20px">
                      カレンダー指定（
                      <b v-if="click_type == 0" style="color:red">除外日</b>
                      <b v-else style="color:#6dffcc">開催期間</b>
                      ）
                    </div>
                    <div>
                      <b>
                        <span style="color:#6dffcc">緑色：</span>開催日、<span style="color:red">赤色：</span>除外日
                      </b>
                    </div>
                  </div>
                  <hr style="width:100%">
               <u v-if="click_type != 0" style="color:red">
                  <template v-if="click_type == 1">
                    開催日の「開始日」を選択してください。
                  </template>
                  <template v-else-if="click_type == 2">
                    開催日の「終了日」を選択してください。
                  </template>
                </u>
                <template v-else>
                  カレンダー上の日付を選択すると除外日となります。<br>
                  ※すでに除外日となっている日付を選択すると、除外日設定が解除されます。
                </template>
              </div>
              <div id="calendar_button_area">
                    <div v-on:click="Change_month(-1)" class="month_change">＜＜前月</div>
                    <div><h2 style="margin:0">{{ calendar_month }} 月</h2></div>
                    <div v-on:click="Change_month(1)" class="month_change">翌月＞＞</div>
                  </div>
                  <div id="title_area" style="border-bottom: 1px solid #000;">
                    <div class="list_column_header calendar_column_left" style="color: red;">日</div>
                    <div class="list_column_header calendar_column">月</div>
                    <div class="list_column_header calendar_column">火</div>
                    <div class="list_column_header calendar_column">水</div>
                    <div class="list_column_header calendar_column">木</div>
                    <div class="list_column_header calendar_column">金</div>
                    <div class="list_column_header calendar_column_right" style="color:blue">土</div>
                  </div>
                  <div id="calendar_area" v-html="Calendar" v-on:click="htmlColumnClick">

                  </div>
              </div>
              <div id="button_area">
                  
              <hr style="width:100%">
                <div style="display: flex; width: 100%; align-items: center; justify-content: space-between;">
                  <div>
                    <template v-if="click_type != 0">
                      
                      <template v-if='main_nittei_list["kaisai_start"] != ""'>
                        <b>開始日：</b>
                      {{DateSetting(main_nittei_list["kaisai_start"])}}
                       ～ 
                      </template>
                      <template v-if='main_nittei_list["kaisai_start"] != ""'>
                      <b>終了日：</b>
                      {{DateSetting(main_nittei_list["kaisai_end"])}}
                      </template>
                    </template>
                    <template v-else>
                      <b>除外日：</b>
                      {{main_nittei_list["jogai_date"]}}
                    </template>
                  </div>
                  <div style="display: flex;flex-direction: row;justify-content: flex-end;">
                    <img src="../../../images/hozon_blue.png" v-on:click="Close_window_add()" style="cursor:pointer;margin-right:10px">
                    <img src="../../../images/close_red.png"  v-on:click="Close_window()" style="cursor:pointer">
                  </div>
                </div>
              </div>
        </div>
        
    </div>

  </template>
  

<script setup>

/* eslint-disable */

    import axios from 'axios'
    // ローカルJavascriptファイルの指定
    import { GlobalData, login_check,getUser_email,youbi_irekae,DateSetting } from '../../js/userdata_shakyo.js'
    
    import { useRouter, useRoute } from 'vue-router'
    import { ref,shallowRef, watch, nextTick  } from 'vue'
   
    // カレンダーで表示する月を算出する
    // 初期値は今日と同じ年月
    let calendar_hyoji_date = new Date()
    let calendar_year = calendar_hyoji_date.getFullYear()
    let calendar_month = calendar_hyoji_date.getMonth() + 1  
    
    // 表示するカレンダー（htmlタグをそのまま記述）
    let Calendar = ref("")

    // 曜日配列
    const youbi_list = ["日","月","火","水","木","金","土","祝"]

    // 親コンポーネント（ShakyoTaikenDetail.vue）から送られてきた値
    const props = defineProps(["param"])
    let flg = ref(props.param.flg) // kaisai or jogai
    let disp_nittei_list = ref(props.param.disp_nittei_list) // 編集する日程（type = 0の場合は空の項目、1の場合は上書きされる）
    let shubetsu = ref(props.param.shubetsu) // プログラムの種別
    let program_num = props.param.program_num // 日程を格納している活動内容の番地。9999はメイン（活動1）

    // 選択モード切替
    let click_type = ref(0) // 0：除外日、1：開始日、2：終了日

    // 表示する日程リスト
    let main_nittei_list = ref(disp_nittei_list.value[0])

    // 保存しない場合に戻すときのリスト
    let return_list = JSON.parse(JSON.stringify(main_nittei_list.value))

    console.log(disp_nittei_list.value[0])
    console.log(main_nittei_list.value)
    console.log(return_list)
    
    // 開催日が入力済みなら、その月を初期表示とする
    if(main_nittei_list.value["kaisai_start"] != ""){

      calendar_hyoji_date = new Date(main_nittei_list.value["kaisai_start"])
      console.log(calendar_hyoji_date)
      calendar_year = calendar_hyoji_date.getFullYear()
      calendar_month = calendar_hyoji_date.getMonth() + 1  
    }
   
    // 祝日を取得
    const calendarId = 'japanese__ja@holiday.calendar.google.com'
    const calendarApiUrl = 'https://www.googleapis.com/calendar/v3/calendars/'
    const apiKey = GlobalData.$holiday_key

    // 祝日を格納する配列
    let holidays_list = []
    
  
  /* 親コンポーネントに関わる関数 */
  const emit = defineEmits(['call'])

  // このウィンドウを閉じる
  let Close_window = function(){
    if(window.confirm("このウィンドウを閉じますか？\n※変更内容は保存されません。")){
      
        console.log(disp_nittei_list.value[0])
        console.log(main_nittei_list.value)
        console.log(return_list)
        disp_nittei_list.value[0] = return_list
        emit('call',{cmd:'close'});
    }
  }

  // 日程設定後、このウィンドウを閉じる
  let Close_window_add = function(){
    
    if(window.confirm("この内容で保存しますか？")){
      let send_array = {"kaisai_start":main_nittei_list.value["kaisai_start"],
      "kaisai_end":main_nittei_list.value["kaisai_end"],
      "jogai_date":main_nittei_list.value["jogai_date"]}
        emit('call',{cmd:'nittei_calendar','disp_nittei_list':send_array,'program_num':program_num});
    }
    
  }

  // カレンダーを表示させる
  let Calendar_set = function(){


    const date = new Date(calendar_year,calendar_month,1)
    const year = date.getFullYear()
    const month = date.getMonth() 

    const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
    const endDate = new Date(year, month,  0) // 月の最後の日を取得
    const endDayCount = endDate.getDate() // 月の末日
    const startDay = startDate.getDay() // 月の最初の日の曜日を取得
    let dayCount = 1 // 日にちのカウント
    let calendarHtml = '' // HTMLを組み立てる変数

    console.log(main_nittei_list.value["kaisai_start"])
    
      // 開催曜日を取得
      let kaisai_list = []
      if(main_nittei_list.value["kaisai_youbi"] != "" && main_nittei_list.value["kaisai_youbi"] != null){
        kaisai_list = main_nittei_list.value["kaisai_youbi"].split("、")
      }
      // 除外曜日を取得
      let jogai_list = []
      if(main_nittei_list.value["jogai"] != "" && main_nittei_list.value["jogai"] != null){
        jogai_list = main_nittei_list.value["jogai"].split("、")
      }
      
      // 除外日を取得
      let jogai_date = []
      if(main_nittei_list.value["jogai_date"] != "" && main_nittei_list.value["jogai_date"] != null){
        jogai_date = main_nittei_list.value["jogai_date"].split("、")
      }



    for (let w = 0; w < 6; w++) {

      // 1週間のうち、日付を入れたカラムを判定する
      let setCount = 0

      let set_html = '<div id="calendar_column_area" >'

        for (let d = 0; d < 7; d++) {
          set_html += '<div class="'
            if(d == 0) {
              set_html += 'calendar_column_left'
            }else if(d == 6){
              set_html += 'calendar_column_right'

            }else{
              set_html += 'calendar_column'
              
            }
            set_html += '">'
            if (w == 0 && d < startDay) {
                // 1行目で1日の曜日の前
                set_html += '<div class="column_date_nittei_blank"></div>'
            } else if (dayCount > endDayCount) {
                // 末尾の日数を超えた
                set_html += '<div class="column_date_nittei_blank"></div>'
            } else {


              // 現在表示する日付をセット
              let setDate = calendar_year+"-"+('00'+(calendar_month)).slice(-2)+"-"+('00'+dayCount).slice(-2)
              let checkHoliday = calendar_year+"/"+calendar_month + "/"+ dayCount

              // 除外日判別用の「月日」のみの変数
              let jogai_day = calendar_month+"/"+dayCount
              

              // 日付を入力（年月日、月日をIDに入力）
              set_html += '<div class="column_date_nittei" id="'+setDate+','+jogai_day+'"' 
              

              // 1なら緑色、2ならピンクに塗る
              let add_ok = 1

              // 開催日の開始日が入力されていた場合
              if(main_nittei_list.value["kaisai_start"] != ""){
                let checkDate = new Date(setDate)
                let set_youbi = checkDate.getDay()
                let mainDateStart = new Date(main_nittei_list.value["kaisai_start"])
                let mainDateEnd = new Date(main_nittei_list.value["kaisai_end"])
                
                // 開催曜日の指定がある場合
                if(kaisai_list.length != 0){
                  // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
                  if(kaisai_list.includes(youbi_list[set_youbi])) {

                  }else{

                    // 開催曜日に祝日がある場合
                    if(kaisai_list.includes("祝")){
                      // 日付が祝日かどうかを確認
                      // 祝日でなければ飛ばして次へ
                      if(!holidays_list.includes(checkHoliday)) {
                        add_ok = 0
                      }
                      
                    }else{
                      add_ok = 0
                    }
                  }
                }else 
                  // 除外曜日の指定がある場合
                  if(jogai_list.length != 0){
                    // 除外曜日に指定した曜日に該当する日の場合
                    // 飛ばして次へ
                    if(jogai_list.includes(youbi_list[set_youbi])) {
                        add_ok = 0
                    }

                    // 除外曜日に祝日がある場合
                    if(jogai_list.includes("祝")){
                      // 日付が祝日かどうかを確認
                      // 祝日であれば飛ばして次へ
                      if(holidays_list.includes(checkHoliday)) {
                        add_ok = 0
                      }
                    }
                }

                // 除外日の指定がある場合
                if(jogai_date.length){
                  // 除外日に該当する日の場合
                  // 飛ばして次へ
                  if(jogai_date.includes(jogai_day)) {
                      add_ok = 2
                  }
                }
                
                // 開催曜日、除外曜日、除外日をクリアした場合（ここまでフラグが0にならなかった）
                if(add_ok == 1){
                  // 日付の範囲内なら色を塗る（フラグ変更なし）
                  if((checkDate >= mainDateStart && checkDate <= mainDateEnd)){
                    
                  }else{
                    // 日付の範囲外なので白
                    add_ok = 0
                  }
                }
              }else{
                // 開催日未指定なので白
                add_ok = 0
              }

              // 開催日であれば背景は緑色
              if(add_ok == 1){
                set_html += " style='background-color:#6dffcc' "
              }
              
              if(add_ok == 2){
                // 除外日は編集で分かりやすいようにピンクで塗る
                set_html += " style='background-color:pink' "
              }
              
              set_html += '>'
              set_html += '<div class="column_date_nittei_day" id="'+setDate+','+jogai_day+'"><span  id="'+setDate+','+jogai_day+'"'

                // 祝 or 日なら赤
                if(holidays_list.includes(checkHoliday) || d == 0){
                  set_html += "style='color:red'"
                }else if(d == 6){

                  // 土なら青
                  set_html += "style='color:blue'"
                }
              set_html += '/>'
              set_html +=  dayCount
              set_html += '</span></div>'

              set_html += '</div>'

              dayCount++
              setCount++
            }
            set_html += '</div>'
        }
        set_html += '</div>'

        // 日付の入ったカラムが1個でもあれば行として追加
        if(setCount !=0){
          calendarHtml += set_html
        }
    }

    Calendar.value = calendarHtml

  }

  // カレンダーの月を加算・減算し、再度カレンダーを表示する
  let Change_month = function(num){
    
    calendar_month = calendar_month + num

    if(calendar_month == 0) {
      calendar_month = 12
      calendar_year = calendar_year -1
    }
    if(calendar_month == 13) {
      calendar_month = 1
      
      calendar_year = calendar_year +1
    }

    console.log(calendar_year+"年"+calendar_month+"月")
    Calendar_set()

  }

  
  // 開催日一時退避
  let before_start = ""
  let before_end = ""

  // 開催日（開始日）選択モードへ変更
  let mode_change = function(){
    before_start = main_nittei_list.value["kaisai_start"]
    before_end = main_nittei_list.value["kaisai_end"]
    click_type.value = 1
    
  }

  // 開催日（開始日）選択モード解除
  let mode_change_cancel = function(){
    main_nittei_list.value["kaisai_start"] = before_start
    main_nittei_list.value["kaisai_end"] = before_end
    Calendar_set()
  }
  
  
  // カレンダーの日付をクリックした時
  let htmlColumnClick = function(e){

    let clicked = e.target.id
    if(clicked == "") return
    let Click_array = clicked.split(",")

    let kaisai_date = Click_array[0] // 開催年月日
    let jogai_day = Click_array[1] // 除外月日

    // 除外日選択の時
    if(click_type.value == 0){
      set_jogai_date(jogai_day)
    }else if(click_type.value == 1){
      // 開催日（開始日）選択の時は両方とも選択
      main_nittei_list.value["kaisai_start"] = kaisai_date
      main_nittei_list.value["kaisai_end"] = kaisai_date
      click_type.value = 2
      Calendar_set()
    }else if(click_type.value == 2){
      // 開催日（終了日）選択の時
      main_nittei_list.value["kaisai_end"] = kaisai_date
      mode_change()
      Calendar_set()
    }
  }


    /* その他の関数 */

  // 除外日を設定する
  let set_jogai_date = function(jogai_day){

    console.log(jogai_day)

    if(!jogai_day || jogai_day == 'undefined'){
      return
    }
    

    if(main_nittei_list.value.jogai_date != "" && main_nittei_list.value.jogai_date != null){
      // 除外日が何かしら設定されている場合は、読点区切りの配列に直す
      let jogaibi_array = main_nittei_list.value.jogai_date.split("、")

      // 指定した日が、除外日として設定されていない場合は格納する
      if(!jogaibi_array.includes(jogai_day)){
        main_nittei_list.value.jogai_date += "、" + jogai_day
      }else{
        // 指定した日と、同じ日付があった場合は除外する
        let set_jogai_text = ""
        for(let j = 0;j<jogaibi_array.length;j++){
          if(jogaibi_array[j] != jogai_day){
            if(set_jogai_text != "" && set_jogai_text != null){
              set_jogai_text += "、"
            }
            set_jogai_text += jogaibi_array[j]
          }
        }
        main_nittei_list.value.jogai_date = set_jogai_text
      }
    }else{
      main_nittei_list.value.jogai_date = jogai_day
    }

    
    Calendar_set()
  }

/* 初期処理 */

// 開催日フラグが立ってたら開催日選択モードから始める
if(flg.value == "kaisai"){
  click_type.value = 1
}

// 祝日を取得してからカレンダー表示
    function loadGoogleCalendarApi() {
        gapi.client.init({
            apiKey: apiKey,
        }).then(() => {
            return gapi.client.request({
            path: calendarApiUrl + encodeURIComponent(calendarId) + '/events'
            })
        }).then((res) => {
            
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            
            // Googleカレンダーで祝日にされてしまっているもの
            let not_holiday = ["雛祭り","クリスマス","母の日","七五三","節分","七夕"]
            const items = res.result.items

            for(let i = 0; i < items.length; i++){
                // 今年と来年の祝日だけ取得
                if(items[i].start.date.substring(0,4) == set_date.getFullYear() ||
                    items[i].start.date.substring(0,4) == (set_date.getFullYear()+1) ){

                        if(!not_holiday.includes(items[i].summary)){
                            let set_date = new Date(items[i].start.date)
                            let set_year = set_date.getFullYear()
                            let set_month = set_date.getMonth() + 1
                            let set_day = set_date.getDate()
                            holidays_list[holidays_list.length] = set_year+"/"+set_month+"/"+set_day
                        }
                }
            }
            console.log(holidays_list)
            Calendar_set()
        }).catch(error => {
            alert("error:"+JSON.stringify(error))          
        })
    }
    gapi.load('client', loadGoogleCalendarApi)
      



</script>



<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:2;
  height:auto;
  text-align: center;
  padding: 1em;
  background:#fff;
  white-space: pre-line;
}
#content_modal button{
    width:120px;
    height: 30px;
    padding: 0;
}

#vy_main{
    height: 90%;
}
.main_list{
    width: 80%;
    float: right;
}



#vy_left_nav{
    float: left;
    height: 100%;
    padding-bottom: 10px;
}

.left_list{ 
    width: 20%;
}

.left_other{
    width: 0%;
    display: none;
}
#title_area,#list_column_area,:deep(#calendar_column_area){
  border-top:1px solid #000;
    display: flex;
    align-items: center;
  }
  
#under_area{
    height:100%;
}
#left_area{
    padding:10px;
    width:38%;
    height:100%;
    text-align:left;
    float:left
}
#right_area{
    width:62%;
    height:100%;
    float:right;
    padding: 10px;
    border-left: 1px solid #d5d5d5;
    background-color: white;
}
#calendar_button_area{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .month_change{
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date_nittei_blank){
    height: 54px;
  }
  :deep(.column_date_nittei){
    cursor:pointer;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_nittei_day){
    height:30px;
    display: flex;
    align-items: center;
  }

  #button_area{
    display: flex; 
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
  }
  .tabgray{
    color:black;
      background-color: #eee;
      pointer-events: none;
  }
  
  .tabgray input{
      background-color: #eee;
      pointer-events: none;
  }
  .tabwhite{
    
    color:black;
      background-color:#fff ;
  }


</style>